/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectPatients = (state: RootState) => state.call;

export const selectPatientAudioCallStatus = createSelector(
  [selectPatients],
  patients => patients.audioCallStatus
);
